export default {
  computed: {
    splitText () {
      return this.text
    }
  },
  methods: {
    getSplitText (d, i) {
      return this.splitText.split(d)[i]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/SplitTextMixin.js